import React, { useEffect, useState } from "react";

import { CloseOutlined, SearchOutlined } from "@ant-design/icons";
import { Input } from "antd";
import { toast } from "react-toastify";

import StyledScrollbar from "../../../../Common/UIComponents/StyledScrollbar";
import CoaTemplateListItem from "./CoaTemplateListItem";

import { getTemplates } from "../../../../../actions/productTemplate";

import { ReactComponent as LoadingDots } from "../../../../../assets/images/common/LoadingDots.svg";

import "./CoaTemplatePanel.css";

export const DEFAULT_COA_TEMPLATE_ID = "default";
export const DEFAULT_COA_TEMPLATE = {
  template_id: DEFAULT_COA_TEMPLATE_ID,
  name: "Genista Biosciences Report",
  isDefault: true,
};

const filterTemplatesBySearch = (templateList, searchValue) => {
  const normalizedSearch = searchValue.trim().toLowerCase();
  if (!normalizedSearch) {
    return templateList;
  }

  return templateList.filter((template) => (
    template.name.toLowerCase().includes(normalizedSearch)
  ));
};

const CoaTemplatePanel = ({
  selectedTemplateId,
  onSelectTemplate,
  onClosePanel,
  side,
}) => {
  const [searchValue, setSearchValue] = useState("");
  const [templateList, setTemplateList] = useState([]);
  const [isLoadingTemplates, setIsLoadingTemplates] = useState(true);

  useEffect(() => {
    let isMounted = true;

    const fetchTemplates = async () => {
      setIsLoadingTemplates(true);
      const response = await getTemplates(side ? { side } : undefined);
      if (!isMounted) {
        return;
      }

      if (!response || !response.success) {
        toast.error("Could not fetch templates.");
        setTemplateList([]);
      } else {
        setTemplateList(response.result);
      }
      setIsLoadingTemplates(false);
    };

    fetchTemplates();

    return () => {
      isMounted = false;
    };
  }, [side]);

  const visibleTemplates = filterTemplatesBySearch(
    [DEFAULT_COA_TEMPLATE, ...templateList],
    searchValue,
  );

  return (
    <div className="CoaTemplatePanel">
      <div className="CoaTemplatePanel__Header">
        <div className="CoaTemplatePanel__HeaderText">
          <div className="CoaTemplatePanel__TitleRow">
            <span className="CoaTemplatePanel__TitleAccent" aria-hidden />
            <span className="CoaTemplatePanel__Title">Choose Templates</span>
          </div>
          <span className="CoaTemplatePanel__Subtitle">Select from your created templates.</span>
        </div>
        <CloseOutlined
          className="CoaTemplatePanel__CloseIcon"
          aria-label="Close templates panel"
          onClick={onClosePanel}
        />
      </div>

      <Input
        className="CoaTemplatePanel__Search"
        placeholder="Search"
        value={searchValue}
        onChange={(event) => setSearchValue(event.target.value)}
        allowClear
        suffix={(
          <button
            type="button"
            className="CoaTemplatePanel__SearchButton"
            aria-label="Search"
            onMouseDown={(event) => event.preventDefault()}
          >
            <SearchOutlined />
          </button>
        )}
      />

      <div className="CoaTemplatePanel__List">
        <StyledScrollbar className="CoaTemplatePanel__ListScroll" autoHide noScrollX>
          <div className="CoaTemplatePanel__ListInner">
            {isLoadingTemplates && (
              <div className="CoaTemplatePanel__Loading" role="status" aria-label="Loading templates">
                <LoadingDots width={28} height={28} fill="#19305A" />
              </div>
            )}
            {!isLoadingTemplates && visibleTemplates.length === 0 && (
              <div className="CoaTemplatePanel__Empty">No templates found.</div>
            )}
            {!isLoadingTemplates && visibleTemplates.map((template) => (
              <CoaTemplateListItem
                key={template.template_id}
                template={template}
                isSelected={String(template.template_id) === String(selectedTemplateId)}
                onSelectTemplate={onSelectTemplate}
              />
            ))}
          </div>
        </StyledScrollbar>
      </div>
    </div>
  );
};

export default CoaTemplatePanel;
